import { i18n } from "@lingui/core"

// Tùy biến KHCN: hạng mục bài đăng và danh sách tỉnh thành.
// Slug hạng mục phải khớp với app/models/enum/category.go
// và dữ liệu tag trong database.

export interface PostCategory {
  slug: string
  label: string
  hint: string
  color: string
}

export const CATEGORY_SLUGS = [
  "y-tuong-khoi-nghiep",
  "giai-phap",
  "nhu-cau-cong-nghe",
  "gop-y-trao-doi",
] as const

export const isCategorySlug = (slug: string): boolean =>
  (CATEGORY_SLUGS as readonly string[]).includes(slug)

// Nhãn và mô tả được dịch theo ngôn ngữ hiện tại.
export const getCategories = (): PostCategory[] => [
  {
    slug: "y-tuong-khoi-nghiep",
    label: i18n._({
      id: "khcn.category.idea",
      message: "Ý tưởng khởi nghiệp",
    }),
    hint: i18n._({
      id: "khcn.category.idea.hint",
      message: "Tôi có ý tưởng khởi nghiệp hoặc sáng kiến mới",
    }),
    color: "2D57ED",
  },
  {
    slug: "giai-phap",
    label: i18n._({
      id: "khcn.category.solution",
      message: "Giải pháp công nghệ",
    }),
    hint: i18n._({
      id: "khcn.category.solution.hint",
      message: "Tôi cung cấp công nghệ, sản phẩm, giải pháp hoặc dịch vụ",
    }),
    color: "16A34A",
  },
  {
    slug: "nhu-cau-cong-nghe",
    label: i18n._({
      id: "khcn.category.innovation",
      message: "Nhu cầu công nghệ",
    }),
    hint: i18n._({
      id: "khcn.category.innovation.hint",
      message: "Tôi đang có nhu cầu và tìm kiếm công nghệ, giải pháp hoặc đối tác",
    }),
    color: "D97706",
  },
  {
    slug: "gop-y-trao-doi",
    label: i18n._({
      id: "khcn.category.discussion",
      message: "Góp ý & Trao đổi",
    }),
    hint: i18n._({
      id: "khcn.category.discussion.hint",
      message: "Góp ý, đặt câu hỏi và trao đổi các vấn đề liên quan",
    }),
    color: "7C3AED",
  },
]

export const getCategory = (
  slug: string
): PostCategory | undefined =>
  getCategories().find((c) => c.slug === slug)

export const DEFAULT_PROVINCE = "Hà Tĩnh"

// 34 tỉnh, thành phố sau sắp xếp năm 2025.
// Phải khớp với app/models/enum/province.go
export const PROVINCES = [
  "Hà Nội",
  "Hải Phòng",
  "Huế",
  "Đà Nẵng",
  "TP. Hồ Chí Minh",
  "Cần Thơ",
  "Lai Châu",
  "Điện Biên",
  "Sơn La",
  "Lào Cai",
  "Tuyên Quang",
  "Cao Bằng",
  "Thái Nguyên",
  "Lạng Sơn",
  "Quảng Ninh",
  "Bắc Ninh",
  "Phú Thọ",
  "Hưng Yên",
  "Ninh Bình",
  "Thanh Hóa",
  "Nghệ An",
  "Hà Tĩnh",
  "Quảng Trị",
  "Quảng Ngãi",
  "Gia Lai",
  "Khánh Hòa",
  "Đắk Lắk",
  "Lâm Đồng",
  "Đồng Nai",
  "Tây Ninh",
  "Đồng Tháp",
  "Vĩnh Long",
  "An Giang",
  "Cà Mau",
]
